'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash');

var _ButtonBar = require('./ButtonBar');

var _ButtonBar2 = _interopRequireDefault(_ButtonBar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // stolen somewhat from https://github.com/ianstormtaylor/slate/tree/master/examples/hovering-menu

/**
 * The hovering menu.
 *
 * @type {Component}
 */


var HoverMenu = function (_React$Component) {
  (0, _inherits3.default)(HoverMenu, _React$Component);

  function HoverMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HoverMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HoverMenu.__proto__ || (0, _getPrototypeOf2.default)(HoverMenu)).call.apply(_ref, [this].concat(args))), _this), _this.renderMarkButton = function (label, type) {
      var value = _this.props.value;
      var active = value.activeMarks.some(function (mark) {
        return mark.type === type;
      }); // return <b>HI</b>

      return _react2.default.createElement('button', {
        key: type,
        className: active ? 'active' : '',
        onMouseDown: function onMouseDown(event) {
          return _this.onClickMark(event, type);
        }
      }, label);
    }, _this.renderBlockButton = function (label, type) {
      var value = _this.props.value; // return <b>HEY</b>

      var active = !!value.blocks.find(function (block) {
        return block.type === type;
      });
      console.log('block button', value.blocks.map(function (block) {
        return block.type;
      }).toJS());
      return _react2.default.createElement('button', {
        key: type,
        className: active ? 'active' : '',
        onMouseDown: function onMouseDown(event) {
          return _this.onClickBlock(event, type);
        }
      }, label);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HoverMenu, [{
    key: 'render',

    /**
     * Render.
     *
     * @return {Element}
     */
    value: function render() {
      var _props = this.props,
          innerRef = _props.innerRef,
          marks = _props.marks,
          blocks = _props.blocks;
      var root = window.document.getElementById('root');
      return _reactDom2.default.createPortal(_react2.default.createElement(_ButtonBar2.default, {
        className: 'HoverMenu',
        innerRef: innerRef
      }, _react2.default.createElement('div', {
        className: 'marks'
      }, (0, _lodash.map)(marks, this.renderMarkButton)), _react2.default.createElement('div', {
        className: 'blocks'
      }, (0, _lodash.map)(blocks, this.renderBlockButton))), root);
    }
  }, {
    key: 'onClickMark',

    /**
     * When a mark button is clicked, toggle the current mark.
     *
     * @param {Event} event
     * @param {String} type
     */
    value: function onClickMark(event, type) {
      var _props2 = this.props,
          value = _props2.value,
          onChange = _props2.onChange;
      event.preventDefault();
      var change = value.change().toggleMark(type);
      onChange(change);
    }
  }, {
    key: 'onClickBlock',
    value: function onClickBlock(event, type) {
      var _props3 = this.props,
          value = _props3.value,
          onChange = _props3.onChange;
      event.preventDefault();
      var change = value.change().setBlocks(type);
      onChange(change);
    }
  }]);
  return HoverMenu;
}(_react2.default.Component);

exports.default = HoverMenu;